/**
 * Kontexthilfe-Mapping: App-Route → Doku-Anker.
 *
 * Das „?“-Icon im Header verlinkt über dieses Mapping auf den passenden
 * Abschnitt der Online-Dokumentation (/dokumentation#<anker>).
 * Längere Präfixe stehen zuerst (z. B. /mitarbeiter/:id vor /mitarbeiter).
 */

const ROUTE_ANKER: Array<{ prefix: string; anker: string }> = [
  { prefix: "/mitarbeiter/", anker: "mitarbeiter-personalakte" },
  { prefix: "/mitarbeiter", anker: "mitarbeiter-verzeichnis" },
  { prefix: "/anwesenheit", anker: "anwesenheit" },
  { prefix: "/schichtplan", anker: "schichtplanung" },
  { prefix: "/abwesenheiten", anker: "abwesenheiten" },
  { prefix: "/urlaub", anker: "urlaub-krank" },
  { prefix: "/schulungen", anker: "schulungen" },
  { prefix: "/vorsorge", anker: "vorsorge" },
  { prefix: "/organisation", anker: "weitere-bereiche-organisation" },
  { prefix: "/dokumente", anker: "weitere-bereiche-dokumente" },
  { prefix: "/betriebskalender", anker: "betriebskalender" },
  { prefix: "/admin/stammdaten", anker: "weitere-bereiche-administration" },
  { prefix: "/", anker: "weitere-bereiche-dashboard" },
]

/** Doku-Anker zur aktuellen Route (Dashboard "/" nur bei exaktem Match) */
export function dokuAnkerFuerPfad(pathname: string): string | null {
  if (pathname.startsWith("/dokumentation")) return null
  for (const { prefix, anker } of ROUTE_ANKER) {
    if (prefix === "/") {
      if (pathname === "/") return anker
      continue
    }
    if (pathname === prefix || pathname.startsWith(prefix)) return anker
  }
  return null
}
